import * as React from "react";
import {
    Routes,
    Route,
    Link,
    useNavigate,
    useLocation,
    Navigate,
    Outlet,
  } from "react-router-dom";
import { unauthenticatedApi, getAccessToken, authenticatedApi, setAccessToken, tokenName, cookieDomain, isImpersonating, impersonatingTokenName } from "../api";
import Cookies from "js-cookie";

/*
interface IAuthContext {
  user: any;
  setUser: Function;// (user) => {},

  can: Function;//(perms) => false,

  userMeta?: object;//null,
  getUserMeta: () => {},
  setUserMeta: (userMeta) => {},

  isLoading: true,
  signIn: (callback) => {},
  signOut: (callback) => {},
}
*/

export const AuthContext = React.createContext({
    user: null,
    setUser: (user) => {},

    can: (perms, requireAll = false) => false,

    userMeta: null,
    getUserMeta: () => {},
    setUserMeta: (userMeta) => {},

    isLoading: true,
    signIn: (email, password) => Promise.resolve(),
    signOut: (callback) => {},
  });

export function useAuth() {
    return React.useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [user, setUser] = React.useState(null);
    const [userMeta, setUserMeta] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);

    const can = (perms, requireAll = false) => {
      if(!user) {
        return false;
      }

      if(perms === null || perms === true) {
        return true;
      }

      // return user.abilities.indexOf(perms) !== -1;
      if(typeof perms === 'string') {
        perms = [perms];
      }

      // reject noop perms
      if(perms[0].indexOf('noop') !== -1) {
        return false;
      }

      // handle super admin
      if(user.roles.find(role => role.id === 0)) {
        return true;
      }

      const hasAllRequired = true;
      for(const perm of perms) {
        // if the permission exists
        if(user.abilities.indexOf(perm) !== -1) {
          // if we're matching ANY perms, return true
          if(!requireAll) {
            return true;
          }
        // if the permission doesn't exist
        } else {
          // if we're requiring all,
          if(requireAll) {
            return false;
            // hasAllRequired = false;
            // break;
          }
        }
      }

      // return false;
      // if we DO require all and we got to this point, we have permission
      // if we DO NOT require all and we got to this point, we do not have permission
      return requireAll;// ?  hasAllRequired : false;
    }

    let signIn = (email, password) => {
      return unauthenticatedApi.post('/token/request', {
        email,
        password,
        token_name: 'web',
      }).then(response => {
        // console.log(response.data);
        setAccessToken(response.data.access_token);
        setUser(response.data.user);
        // console.log(response.data.user);
      });
    };

    let signOut = () => {
      return new Promise((resolve, reject) => {
        if(isImpersonating) {
          Cookies.remove(impersonatingTokenName, {
            domain: cookieDomain,
          });

          window.location.reload();
          return;
        }

        Cookies.remove(tokenName, {
          domain: cookieDomain,
        });

        // authenticatedApi.get('/revoke-token');

        setUser(null);
        window.location.href = '/login';

        resolve();
      });
    };

    const getUserMeta = () => {
      authenticatedApi.get('/user-meta').then(response => {
        setUserMeta(response.data);
      })
    }

    React.useEffect(() => {
      let checkToken = getAccessToken();

      if(!checkToken) {
        setIsLoading(false);
        if(
          window.location.href.indexOf('/login') === -1
          && window.location.href.indexOf('volunteer-signup') === -1
        ) {
          window.location.href = '/login';
        }
        return;
      }

      // console.log(user);
      // console.log(checkToken);
      if(isLoading && user == null/* && checkToken != ''*/) {
        authenticatedApi.get('/users/current').then(response => {
          /*
          let dupedResponse = response.data;
          // delete dupedResponse['installs'];
          delete dupedResponse['contacts'];
          setUser(dupedResponse);
          */

          setUser(response.data);

          // getUserMeta();
        }).catch(e => {
          // if(window.location.href.indexOf('/login') === -1) {
            if(
              window.location.href.indexOf('/login') === -1
              && window.location.href.indexOf('volunteer-signup') === -1
            ) {
              window.location.href = '/login';
            }
          // }
          // log user out & redirect back to login screen
        }).finally(() => {
          // setTimeout(() => {
            setIsLoading(false);
          // }, 1000);
        });
      }
    }, [user]);


    let value = {
      user,
      setUser,
      isLoading,

      can,

      userMeta,
      getUserMeta,
      setUserMeta,

      signIn,
      signOut,

      // installSettings,
      // setInstallSettings,
      /*connectedAccounts, setConnectedAccounts, getConnectedAccounts,*/
    };


    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function RequireAuth({ children }) {
    let auth = useAuth();
    let location = useLocation();

    if (!auth.user) {
      // Redirect them to the /login page, but save the current location they were
      // trying to go to when they were redirected. This allows us to send them
      // along to that page after they login, which is a nicer user experience
      // than dropping them off on the home page.
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}

export function RequireGuest({ children }) {
    let auth = useAuth();
    let location = useLocation();

    let from = location.state?.from?.pathname || "/";

    if (auth.user) {
      return <Navigate to={from} replace />;
    }

    return children;
}
